const en = {
  Hem: "Home",
  "Simone Trollmo": "Simone Trollmo",
  "Byt språk": "Change language",
  "Byt tema": "Change theme",
  Kontakt: "Contact",
  Meny: "Menu",
  Undervisning: "Lessons",
  "Terminer & priser": "Terms & prices",
  Övning: "Practice",
  "Boka & kontakt": "Book & contact",
  "Fiol & Celloundervisning": "Violin and Cello lessons",
  "Stockholm Stråkstudio": "Stockholm Stråkstudio",
  "Logga in med": "Login with",
  Suzukifiol: "Suzuki Violin",
  "genom Bromma Hässelby Suzukiförening":
    "through Bromma Hässelby Suzukiförening",
  Fiollektioner: "Violin lessons",
  Admin: "Admin",
  Meddelanden: "Messages",
  Innehållshantering: "Pages",
  Anmälningar: "Applications",
  "Fiol barn": "Violin kids",
  "Fiol för barn": "Violin lessons",
  "VT 2026": "Spring term 2026",
  "Sommarkurs 2026": "Summer course 2026",
  Celloundervisning: "Cello lessons",
  Övningstips: "Practice Tips",
  Övningsvideor: "Practice Videos",
  "Sök videor...": "Search videos...",
  "Inga videor hittades": "No videos found",
  "Laddar fler videor...": "Loading more videos...",
  "Visar {count} av {total} videor": "Showing {count} of {total} videos",
  Anmälan: "Sign up",
  Analys: "Analytics",
  Ansökningar: "Applications",
  Ansökningsdatum: "Application date",
  "Barnets namn": "Child's name",
  "Förälderns namn": "Parent's name",
  "Ny anmälan från": "New application from",
  "Förälderns namn: ": "Parent name: ",
  "Barnets namn (för- och efternamn)": "Child's name (first and last name)",
  "Barnets personnummer": "Child's personal number",
  "Förälderns namn (för- och efternamn)": "Parent's name (first and last name)",
  "Förälderns personnummer": "Parent's personal number",
  Email: "Email",
  Telefonnr: "Phone number",
  "Postadress och ort": "Postal address and city",
  Lektionstyp: "Lesson type",
  Suzukiundervisning: "Suzuki lessons",
  "Mer om Suzukiundervisning finns här":
    "More about Suzuki lessons can be found here",
  "Traditionell undervisning": "Traditional lessons",
  Lektionslängd: "Lesson length",
  "20min": "20min",
  "30min": "30min",
  "45min": "45min",
  "60min": "60min",
  "20 minuter": "20 minutes",
  "30 minuter": "30 minutes",
  "45 minuter": "45 minutes",
  "60 minuter": "60 minutes",
  "Tack för din anmälan!": "Thank you for your application!",
  "Något gick fel... Kontrollera alla fält och försök igen.":
    "Something went wrong... Check all fields and try again.",
  "Jag godkänner villkoren enligt nedan": "I accept the terms below",
  "Jag har läst information om priser":
    "I have read the information about prices",
  "Du måste ange personnummer": "You must enter a personal number",
  "Personnummer måste vara minst 12 siffror":
    "Personal number must be at least 12 digits",
  "Personnummer får vara max 12 siffror":
    "Personal number can be max 12 digits",
  "Du måste ange adress": "You must enter an address",
  "Adressen måste vara minst 15 bokstäver och siffror":
    "The address must be at least 15 letters and numbers",
  "Du måste välja lektionstyp": "You must choose a lesson type",
  "Du måste välja lektionslängd": "You must choose a lesson length",
  "Du måste acceptera villkoren": "You must accept the terms",
  "Du måste acceptera prisinformation": "You must accept the price information",
  Bokningsvillkor: "Booking terms",
  "Samtliga priser är inklusive moms.": "All prices include VAT.",
  "14 dagars ångerrätt. Om eleven hunnit påbörja terminen utgår faktura för de lektioner som redan varit samt en administrativ avgift om 200kr.":
    "14 days right of withdrawal. If the student has already started the semester, an invoice will be issued for the lessons that have already been held plus an administrative fee of 200 SEK.",
  "Betalning ska ske inom 30 dagar netto. Dröjsmålsränta är 6% och påminnelseavgiften 60kr.":
    "Payment must be made within 30 days net. Default interest is 6% and the reminder fee is 60 SEK.",
  "GDPR Policy": "GDPR Policy",
  "Vi delar inte våra kunders uppgifter med tredje parter. För att kunna fakturera behöver vi namn, adress och telefonnummer samt mejladress. Personnr behövs för Suzukiundervisning eftersom detta sker i samarbete med ett studieförbund.":
    "We do not share our customers' information with third parties. In order to invoice, we need name, address and telephone number as well as email address. Personal number is required for Suzuki lessons as this is done in collaboration with a study association.",
  "Vi lagrar bara personuppgifter så länge personen är kund hos oss. Om kundrelationen avslutas behåller vi uppgifter i upp till två år.":
    "We only store personal data as long as the person is a customer with us. If the customer relationship is terminated, we retain information for up to two years.",
  "Planerad frånvaro/sjukfrånvaro:": "Planned absence/sick leave:",
  "Upp till 2 lektioner kan ersättas vid sjukdom. Det kan krävas lite flexibilitet av eleven om man vill ta igen en missad lektion.":
    "Up to 2 lessons can be replaced in case of illness. It may require some flexibility from the student if one wants to make up for a missed lesson.",
  "Om man i god tid i förväg meddelar att man kommer vara frånvarande och pedagogen har möjlighet att hitta ett annat lektionstillfälle går detta bra. Det är dock inte givet att man kommer kunna hitta en ersättningstid. Det finns ingen möjlighet att ta igen missade lektioner som man inte meddelat i förväg (om det inte gäller sjukfrånvaro).":
    "If one informs well in advance that one will be absent and the teacher has the opportunity to find another lesson time, this is fine. However, it is not certain that a replacement time will be found. There is no possibility to make up for missed lessons that have not been notified in advance (unless it concerns sick leave).",
  "Den sidan finns inte.": "The page does not exist.",
  "Vi kunde inte hitta sidan du letade efter. Kanske är adressen felstavad? Var god kontrollera stavningen och försök igen.":
    "We could not find the page you were looking for. Maybe the address is misspelled? Please check the spelling and try again.",
  "Gå till startsidan": "Go to the homepage",
  "Simone Trollmo är en violinist och fiollärare i Stockholm.":
    "Simone Trollmo is a violinist and violin teacher in Stockholm.",
  "Vill du lära dig fiol i vuxen ålder eller vill ditt barn spela suzukifiol enligt Suzukimetoden? Hos Stockholm Stråkstudio finns undervisning i fiol till barn och vuxna i Stockholm. För närvarande finns fiolundervisning i Bromma, Vällingby samt i Solna.":
    "Do you want to learn the violin as an adult or do you want your child to play Suzuki violin according to the Suzuki Method? At Stockholm Stråkstudio there is violin teaching for children and adults in Stockholm. Currently, violin lessons are available in Bromma, Vällingby and in Solna.",
  "Undervisning i fiol och cello enligt Suzukimetoden™️":
    "Violin and cello lessons according to the Suzuki Method™",
  "Undervisning i fiol och cello i Stockholm för barn från 3 år och uppåt. För närvarande finns vi i Bromma, Vällingby samt i Solna.":
    "Violin and cello lessons in Stockholm for children from 3 years and up. We are currently located in Bromma, Vällingby and Solna.",
  "Observera att det bara finns enstaka platser kvar på fiol. Ställ gärna ert barn i kö för att försäkra er om en plats":
    "Please note that there are only a few spots left for violin. Please put your child on the waiting list to secure a spot.",
  "Simone är utbildad violinist och fiollärare samt även certifierad Suzukilärare.":
    "Simone is a trained violinist and violin teacher as well as a certified Suzuki teacher.",
  "Logga ut": "Sign out",
  Videohantering: "Video management",
  Waldorfdockor: "Waldorf Dolls",
  "Fiollektioner i Stockholm för barn och vuxna":
    "Violin lessons in Stockholm for children and adults",
  Textilkonstnär: "Textile Artist",
  "Syr waldorfdockor på beställning": "Sews Waldorf dolls by custom order",
  "Vill du lära dig spela fiol?": "Do you want to learn to play the violin?",
  "Jag erbjuder fiollektioner för barn och vuxna.":
    "I offer violin lessons for children and adults.",
  "Kontakta oss": "Contact us",
  "All rights reserved": "All rights reserved",
  "made by": "made by",
  "Emanuel Franzen": "Emanuel Franzen",
  "Pojke tar fiollektioner i Stockholm":
    "Boy taking violin lessons in Stockholm",
  "Fiollektioner i Stockholm": "Violin Lessons in Stockholm",
  "Fiollektioner för barn & ungdom i Stockholm hos Stockholm Stråkstudio":
    "Violin lessons for children & youth in Stockholm at Stockholm Stråkstudio",
  "Obs att flera av dagarna listade nedan är fullbelagda men det går bra att ställa sig i kö ":
    "Note that several of the days listed below are fully booked but you can join the waiting list ",
  "Lördagar: Kristofferskolan vid Brommaplan":
    "Saturdays: Kristofferskolan at Brommaplan",
  "Söker du en fiollärare i Stockholm?":
    "Are you looking for a violin teacher in Stockholm?",
  "Simone är utbildad violinist och har sedan vidareutbildat sig till fiollärare vid Stockholms Musikpedagogiska Institut för Päivikki Wirkkala Malmqvist. Simone är också utbildad Suzukilärare i fiol och erbjuder även Suzukifiol vilket du också kan läsa om ":
    "Simone is a trained violinist and has further trained to become a violin teacher at Stockholms Musikpedagogiska Institut with Päivikki Wirkkala Malmqvist. Simone is also a trained Suzuki violin teacher and offers Suzuki violin which you can also read about ",
  "Simone är utbildad violinist och har sedan vidareutbildat sig till fiollärare vid Stockholms Musikpedagogiska Institut för Päivikki Wirkkala Malmqvist. Simone är också utbildad Suzukilärare i fiol och erbjuder även Suzukifiol vilket du också kan läsa om här på sidan.":
    "Simone has a background as a performing violinist and has later complemented her education with string pedagogy courses at Stockholms Musikpedagogiska Institut and through the Colourstrings Institute. She is also a certified Suzuki teacher which you can also read about on this page.",
  här: "here",
  ".": ".",
  "I Simones fiolundervisning läggs stor vikt vid ergonomi och att bygga bra grunder för violintekniken. Spelandet ska vara lustfyllt vilket kräver en god relation mellan lärare, elev och förälder samt en trygg miljö. Föräldern närvarar alltid vid lektionerna samt övar med barnet hemma. För att lära sig ett instrument krävs frekvent övning, helst varje dag!":
    "In her teaching, Simone places great emphasis on healthy movement and building a solid technique. The relationship with each student is important and teaching method and repertoire is adjusted according to the student’s needs.",
  "Fiolundervisningen sker främst i Bromma samt en dag i centrala Stockholm (för närvarande lördagar). Till vårterminen 2024 planerar Simone också att börja undervisa vid Hagaskolan i Hagalund, Solna, om det finns tillräckligt med intresse.":
    "Violin lessons are held in Bromma and one day a week in central Stockholm (currently Saturdays). From spring term 2024, Simone also plans to teach at Hagaskolan in Hagalund, Solna, if there is enough interest.",
  "Hör av dig via kontaktformuläret här ovan om du är intresserad av fiollektioner.":
    "Please Contact us via the contact form above if you are interested in violin lessons.",
  "Hör av dig via kontaktformuläret om du är intresserad av celloundervisning.":
    "Please contact us via the contact form if you are interested in cello lessons.",
  Priser: "Prices",
  "Priser VT 2024, 15 undervisningstillfällen. Utöver detta tillkommer en avgift om 175:- för elevkonsert. Alla priser är inkl. moms.":
    "Prices Spring semester 2024: 15 lessons, prices include VAT. There is an additional fee for the student concert.",
  Längd: "Length",
  "Pris (kr)": "Price (SEK)",
  "Enbart gruppspel (obs att gruppspel ingår i avgifterna ovan, detta är för elever som inte tar individuella lektioner hos oss): 1500:-":
    "Only group play (note that group play is included in the fees above, this is for students who do not take individual lessons with us): 1500 SEK",
  "Gruppspel syskon: 1000:-": "Group play siblings: 1000 SEK",
  "Syskon kan dela på 30, 45 eller 60min men måste då köpa till gruppspel för det syskonet/syskonen.":
    "Siblings can share 30, 45 or 60 minutes but must then purchase group play for that sibling/siblings.",
  "Kontakta oss gärna.": "Please Contact us.",
  Namn: "Name",
  Telefonnummer: "Phone number",
  Ämne: "Subject",
  Meddelande: "Message",
  Skicka: "Send",
  "Meddelande skickat!": "Message sent!",
  "Tack för ditt meddelande. Jag hör av mig så snart jag kan.":
    "Thank you for your message. I will get back to you as soon as I can.",
  "Meddelande kunde inte skickas!": "The message could not be sent!",
  "Anmälan skickad!": "Application sent!",
  "Tack för din anmälan. Jag återkommer av mig så snart jag kan.":
    "Thank you for your application. I will get back to you as soon as I can.",
  "Nytt meddelande från": "New message from:",
  "Namn: ": "Name: ",
  "Email: ": "Email: ",
  "Telefonnummer: ": "Phone: ",
  "Meddelande: ": "Message:",
  "Besök strakstudio.se": "Visit strakstudio.se",

  "Hej, välkommen tillbaka!": "Hi, Welcome back!",
  "gjord av": "made by",
  "läs vår": "read our",
  "läs mer": "read more",
  integritetspolicy: "privacy policy",

  Karta: "Map",
  "Kartan kunde inte laddas.": "The map couldn't be loaded.",
  "Söker du en fiollärare för ditt barn i Stockholm?":
    "Are you looking for a violin teacher in Stockholm?",
  "Fiolundervisningen finns i Bromma, Solna samt från och med höstterminen 2024 även i Vällingby.":
    "Violin lessons are held in Bromma, Solna and from autumn term 2024 also in Vällingby.",
  "Priser VT 2026, 14 undervisningstillfällen. Alla priser är inkl. moms.":
    "Prices spring term 2026: 14 lessons, prices include VAT.",
  "Priser, VT 2026, 14 lektioner inkl. moms:":
    "Prices, spring term 2026, 14 lessons incl. VAT:",
  "Om Simone": "About Simone",
  "Om David": "About David",
  "Om oss": "About Us",
  "David är cellist utbildad som musiklärare med cello inriktning i Universidad Tecnológica de Pereira i sitt hemland Colombia och har sedan vidareutbildat som cellist i masterprogram I Longy School of Music, USA för Terry King. David är också utbildad som Suzukilärare och erbjuder också Suzukicello. David har stort intresse för alla musikgenrer och spelstilar från klassisk till pop och rock och allt däremellan. Som en cellist med en sena startsträcka, David har som största syfte att dela musik med alla oavsett deras ålder eller bakgrund och I många år har han jobbat med El Sistema filosofi I Colombia, USA och Sverige, där musik används som ett verktyg till social utveckling. Han är för närvarande cellolärare vid Sundbybergs Kulturskola och Stockholms Stråkstudio.":
    "David is a cellist with a degree in music education with emphasis on cello from the Universidad Tecnológica de Pereira in his homeland of Colombia and then in a master of music program in cello from Longy School of Music in USA under the guidance of Terry King. David is also trained in the Suzuki method and offers Suzukicello lessons. David has a great interest in all music genres and styles of playing from classical to pop and rock and everything in between. As a cellist with a late start, David has as his biggest purpose to share music with everyone regardless of their age or background and for many years has worked with the El Sistema philosophy which uses music as a tool of social change in Colombia, USA and Sweden. He is currently a cello teacher in Kulturskola Sundbyberg and Stockholms Stråkstudio.",
  'Stockholms Stråkstudios grundare Simone Trollmo är en violinist baserad i Stockholm som gärna utforskar den breda repertoar som finns för violin och särskilt det utrymme för improvisation och frihet som finns inom barockmusiken. Hon har studerat vid Trinity Laban Conservatoire i London och sedan specialiserat sig inom barockmusik vid Longy School of Music of Bard College i Boston, med en senare doktorand-utbildning vid Boston University. Hennes avhandling "A Method-Based Approach to Historical Violin Playing: Performance Practice from a Contemporary Perspective" finns tillgänglig online.':
    'The founder of Stockholm Stråkstudio, Simone Trollmo, is a violinist based in Stockholm who likes to explore the broad repertoire for violin and particularly the freedom and room for improvisation that is found within early music. She has studied at Trinity Laban Conservatoire in London and later specialized in early music at Longy School of Music of Bard College in Boston, and later at Boston University where she pursued her Doctor of Musical Arts Degree. Her dissertation titled "A Method-Based Approach to Historical Violin Playing: Performance Practice from a Contemporary Perspective" is available online.',
  "Simone har ett stort intresse för kammarmusik och har varit med och grundat Ensemble Sol & Måne som för tillfället är aktuella med en ny barnföreställning.":
    "Simone has a great interest for chamber music and is one of the founding members of Ensemble Sol & Måne, currently taking bookings for their new children's show.",
  "Förutom det egna spelet har Simone ett stort engagemang för pedagogik och brinner för att dela sin glädje för musiken med andra människor. Simone har vidareutbildat sig vid Stockholms Musikpedagogiska Institut och sedan specialiserat sig som Suzukilärare med Päivikki Wirkkala Malmqvist och Jan Matthiesen. Hon har även gått fortbildningskurser i bl a Colourstrings-metoden som är baserad på Kódaly metodik som även fortsättningsvis inspirerar hennes undervisning. Hon har tidigare bl a undervisat vid Kulturskolan Stockholm, Medborgarskolan Lidingö samt New School of Music i Cambridge, MA.":
    "Aside from performing, Simone has a strong passion for pedagogy and holds a desire to share her joy for music with other people. She has studied pedagogy at Stockholms Musikpedagogiska Institut, completed some courses of Colourstrings Teaching Training and completed two levels of Suzuki Teacher Training. She has previously taught at Kulturskolan Stockholm and Medborgarskolan Lidingö but at the moment works for her own business Stockholm Stråkstudio.",
  Plats: "Location",
  "Ange plats...": "Enter location...",
  "Måndagar: Kristofferskolan vid Brommaplan":
    "Mondays: Kristofferskolan at Brommaplan",
  "Onsdagar, Torsdagar, Lördagar: Rättar Vigs Väg i Vällingby":
    "Wednesdays, Thursdays, Saturdays: Rättar Vigs Väg in Vällingby",
  "Onsdagar, Torsdagar, Rättar Vigs Väg i Vällingby":
    "Wednesdays, Thursdays: Rättar Vigs Väg in Vällingby",
  "Fredagar: Hagaskolan i Hagalund": "Fridays: Hagaskolan in Hagalund",

  "Lär dig spela fiol enligt Suzuki™metoden!":
    "Learn to play the violin through the Suzuki™Method!",
  "Lär dig suzukifiol i Stockholm!": "Learn Suzuki violin in Stockholm!",
  "För att ställa dig i kö till Suzukifiol, klicka här":
    "To join the waiting list for Suzuki violin, click here",
  "Alla barn kan lära sig ett instrument! Spela fiol enligt suzukimetoden för Simone som är certifierad Suzukilärare. Spelar man Suzukifiol ses man två gånger i veckan för en individuell lektion och en grupplektion. Metoden bygger på samarbete och tillit mellan barn, förälder och lärare. Föräldern är viktig del av undervisningen och undervisar barnet i hemmet mellan lektionerna.":
    "All children can learn to play an instrument! Learn to play the violin with Simone who is a certified Suzuki violin teacher. When learning according to the Suzuki method, you meet your teacher twice a week for an individual lesson and a group lesson. The parent is very involved and teaches the child at home in-between lessons. There is a lovely community of Suzuki students around the world and many camps that children can take part in. The social aspect is important when learning according to the method and many friendships created during group lessons and camps.",
  "Flicka lär sig spela fiol med suzukimetoden i Stockholm":
    "Girl learning to play the violin with the Suzuki™ Method in Stockholm",
  "Suzuki™metoden kallas också för modersmålsmetoden och bygger på principen att man kan lära sig ett instrument på samma sätt som man lär sig att tala. Metoden utvecklades av Shin’ichi Suzuki i Japan efter andra världskriget och har sedan spridit sig över världen. En viktig del i filosofin är att alla barn har talang: liksom alla barn kan lära sig prata kan alla barn lära sig att spela ett instrument. Eftersom man lär sig på samma sätt som man lär sig tala, genom imitation, börjar man tidigt. En bra lucka att börja i är mellan 3-6 års ålder men Simone tar emot barn i alla åldrar.":
    "The Suzuki™ Method is also called the mother tongue method and builds on the the principle that one can learn an instrument in the same manner as learning one's' native tongue. The method was developed by Shin’ichi Suzuki in Japan after the Second World War and has since spread over the world. An important part of the method is the principle that all children possess talent: since all children can learn to speak, all can learn to play an instrument. To learn an instrument in the same manner as learning to speak, that is by imitation a child should ideally start early. A good age to start is between 3 and 6 years’ old, however, Simone accepts children of all ages into the Suzuki program.",
  "Eftersom små barn lär sig bäst genom imitation sker undervisningen först på gehör. Att lyssna på inspelningar med Suzuki™-repertoaren hemma är obligatoriskt och snabbar på inlärningen. Precis som vid inlärningen av modersmålet ska musiken finnas i omgivningen så mycket som möjligt.":
    "As small children learn best by imitation, they are first taught to play by ear. To listen to recordings with the Suzuki™ repertoire is therefore compulsory and speeds up the learning. Just as with learning the mother tongue, the music is to be present as much as possible in the child’s environment.",
  "En annan viktig byggsten är repetition av redan inlärd repertoar. Till skillnad från många andra fiolböcker så stiger varje stycke i Suzuki™-repertoaren i svårighetsgrad. Genom att hela tiden repetera alla stycken som man lärt sig, tar man lättare till sig det nya stycket. Man har dessutom en gemensam repertoar med andra som också undervisas enligt metoden som gör att man lätt kan spela tillsammans på konserter - var som helst i världen. Ibland kan man som elev eller förälder förledas att jämföra sig/sitt barn med var andra befinner sig i böckerna. Det är viktigt att påpeka att alla barn lär sig i sin egen takt och behöver få den tid på sig att mogna som just de behöver.":
    "Repetition is another important building block of the method. Unlike many other violin methods the pieces in the Suzuki™ repertoire increase in difficulty with each new piece. By repeating the pieces one has already learned, it is easier to learn new repertoire. Besides, it creates a chore repetoire shared with all those also taught by the method around the world that makes it easy to play together. Sometimes, a parent can be tempted to compare their child with other children according to where they are in the Suzuki™ books. It is important to remind all parents that all children develop at their own pace and needs to be given the time that is necessary for them.",
  "När man undervisas enligt Suzuki™metoden har man både individuella lektioner varje vecka samt grupplektioner. Under grupplektionerna kan man repetera redan inlärd teknik men också få chansen till samspel och att stärka de sociala banden. Det är en stor fördel att få se en lärare två gånger i veckan och den sociala aspekten är mycket betydelsefull.":
    "When taught by the method, students also have weekly group lessons besides the individual lessons. This gives an opportunity to repeat technique that has already been taught but also to facilitate ensemble playing and to strengthen social ties. It is a big advantage to see one’s teacher twice a week and the social aspect is especially important!",
  "Föräldern är mycket viktig i Suzuki™metoden. Den närvarar vid alla fiollektioner både individuella och i grupp, observerar och noterar och övar med barnet hemma. Innan barnet börjar med sina lektioner får därför föräldern gå en föräldrakurs där hen får lära sig grunderna på instrumentet.":
    "The parent is very important in the Suzuki™ Method. The parent is present at all violin lessons, both individual and group, observes and takes notes and practices with the child at home. Before the child starts with their lessons, the parent therefore takes a parent course where they learn the basics of the instrument.",
  "Föräldern är mycket viktig i Suzuki™metoden. Den närvarar vid alla fiollektioner både individuella och i grupp, observerar och noterar och övar med barnet hemma. Innan barnet börjar med sina lektioner får därför föräldern gå en föräldrakurs där hen får lära sig grunderna på instrumentet samt lite om filosofin bakom metoden.":
    "Before a child begins to take lessons, the parent takes part in a parents' course where they are taught the foundations of the instrument and also learn about the Suzuki™ philosophy. The course is concluded with a little informal concert.",
  "Priser: Priser inkluderar inviduella lektioner x 14 samt grupplektioner om 45min x 14.":
    "Prices: Prices include individual lessons x 14 and group lessons x 14.",
  "Om du är intresserad av Suzukifiol, Kontakta oss på länken ovan.":
    "If you are interested in having Suzuki™ violin lessons, Contact us on the link above.",
  "Dockor i waldorfstil": "Waldorf dolls and Handwork",
  "Simone syr dockor i naturmaterial stoppade med certifierad ekologisk ull på beställning. Hon ger också kurser i hur man syr en waldorfdocka. Simone syr också födelsedagskronor i ullfilt som är nålfiltade och/eller broderade på beställning.":
    "Simone sews Waldorf dolls made by natural materials filled with certified organic sheep’s wool by custom order. She also teaches doll sewing courses by request. Simone also sews Waldorf Birthday Crowns made by wool felt that are needle felted or embroidered by custom order.",
  Prislista: "Price list",
  Produkt: "Product",
  "Stor docka ca 40cm lång": "Large doll ca 40cm tall",
  "Mellan docka ca 30cm lång": "Medium doll ca 30cm",
  "Liten docka ca 20cm lång": "Small doll ca 20cm",
  "Velourdocka ca 20cm lång": "Cuddle doll in velour ca 20cm",
  "Waldorfdocka för nyfödd i knytmodell": "Waldorf doll for newborn",
  "Födelsedagskrona i ullfilt": "Waldorf birthday crown",
  "Följ på Instagram": "Follow on Instagram",
  "Följ mig på Instagram": "Follow me on Instagram",

  "Du måste ange namn": "Name is required",
  "För kort namn": "Too short name",
  "Du måste ange mailadress": "Email address is required",
  "Felaktig mailadress": "Invalid email address",
  "Du måste ange telefonnummer": "Phone number is required",
  "Telefonnummer måste vara minst 7 siffror":
    "Phone number must be at least 7 digits",
  // Waiting List
  Kölista: "Waiting List",
  "Namn barn": "Child's name",
  Födelseår: "Birth year",
  "Du måste ange födelseår": "You must enter a birth year",
  "Födelseår måste vara 4 siffror": "Birth year must be 4 digits",
  "Önskat startdatum (t ex HT 2026)":
    "Desired start date (e.g., autumn term 2026)",
  "Du måste ange önskat startdatum": "You must enter a desired start date",
  "Önskat startdatum": "Desired start date",
  "Önskad undervisningsplats": "Desired teaching location",
  "Du måste välja undervisningsplats": "You must choose a teaching location",
  "Jag vill ställa mitt barn i kö till:":
    "I want to put my child on the waiting list for:",
  Suzukicello: "Suzuki Cello",
  Barnkör: "Children's choir",
  "Du måste välja minst ett alternativ": "You must choose at least one option",
  "Namn förälder": "Parent's name",
  Kristofferskolan: "Kristofferskolan",
  Hagaskolan: "Hagaskolan",
  Vällingby: "Vällingby",
  "Kölista skickad!": "Waiting list submitted!",
  "Tack för din anmälan till kölistan. Jag återkommer av mig så snart jag kan.":
    "Thank you for your waiting list application. I will get back to you as soon as I can.",
  "Ny kölista från": "New waiting list entry from",
  "Barnets namn: ": "Child's name: ",
  "Födelseår: ": "Birth year: ",
  "Önskat startdatum: ": "Desired start date: ",
  "Önskad undervisningsplats: ": "Desired teaching location: ",
  Datum: "Date",
  "ställ er i kö": "join the waiting list",
  "Du måste ange ämne": "Subject is required",
  "Du måste ange meddelande": "You must enter a message",
  "Meddelandet måste vara minst 10 tecken":
    "Message must be at least 10 characters",
  "Captcha-widgeten kunde inte laddas. Försök ladda om sidan.":
    "The captcha widget couldn't be loaded. Please refresh the page.",
  "Formuläret kan inte skickas utan att captcha är löst.":
    "The form cannot be submitted without completing the captcha.",

  "Många föräldrar tycker att det är knepigt att komma igång med fiol-övningen hemma. Precis som med alla nya vanor tar det ett tag att etablera.":
    "Many parents find it tricky to get started with violin practice at home. Just like with all new habits, it takes a while to establish.",
  "Mitt största tips är att försöka göra det till en del av den dagliga rutinen. Helst ska man öva vid samma tillfälle varje dag (och välja ett sådant tillfälle att det faktiskt går att öva vid samma tid hela veckan, att det inte är en tid då man vissa dagar är borta för aktiviteter). Om barnet förväntar sig att övningen ska ske vid en viss tidpunkt varje dag, liksom hen behöver borsta tänderna morgon och kväll varje dag, brukar det bli mindre konflikter.":
    "My biggest tip is to try to make it a part of the daily routine. Ideally, you should practice at the same time every day (and choose a time that actually works every day of the week, a time when you are not away for activities some days). If the child expects the practice to take place at a certain time every day, just like they need to brush their teeth morning and evening every day, there are usually fewer conflicts.",
  "Förälderns jobb är att om möjligt få barnet att känna att övningen är lustfylld och så rolig att hen VILL öva! Men vi är alla människor och det kommer inte vara så varje dag - känn ingen stress över detta eller tänk att ni har misslyckats. Det kommer att komma bra övningsstunder och mindre bra övningsstunder, det är helt okej!":
    "The parent's job is to, if possible, make the child feel that practice is enjoyable and so fun that they WANT to practice! But we are all human and it will not be like that every day - do not feel stressed about this or think that you have failed. There will be good practice sessions and less good practice sessions, that is perfectly okay!",
  "Att lusten att öva går upp och ned betyder inte att barnet inte gillar att spela sitt instrument i stort. Det speglar mer dagsform och var barnet befinner sig i sin utveckling.":
    "The desire to practice goes up and down does not mean that the child does not like playing their instrument in general. It reflects more the child's daily form and where they are in their development.",
  "Några konkreta övningstips:": "Some concrete practice tips:",
  "Mindre barn älskar lekar i alla dess former. Det spelar ingen roll hur ”konstig” leken än är (föräldern kanske är trött och har brist på fantasi), så länge barnet gillar den och är mera villig att öva är allt bra! Här kommer några exempel på lekar:":
    "Young children love games in all forms. It doesn't matter how “strange” the game is (the parent may be tired and lack imagination), as long as the child likes it and is more willing to practice, everything is fine! Here are some examples of games:",
  "Samla poäng för varje genomfört element/stycke. T ex leksaker, duplobitar (vi brukar bygga torn), mynt, chokladpengar…. Snåla inte :)":
    "Collect points for each completed element/piece. For example, toys, Lego pieces (we usually build towers), coins, chocolate coins…. Do not be stingy :)",
  "Tävlingar i alla dess former, föräldern mot barnet (men se till att barnet vinner, utan att det är alltför uppenbart!).":
    "Competitions in all forms, parent against child (but make sure the child wins, without it being too obvious!).",
  "Gosedjur/legogubbar etc som är kontrollanter av den teknik man för tillfället jobbar med.":
    "Stuffed animals/Lego figures etc that are supervisors of the technique you are currently working on.",
  "Olika typer av rollspel, använd gärna olika röster!":
    "Different types of role-playing, use different voices!",
  "Barn vill som bekant gärna bestämma själva. Låt barnet få vara delaktig i sin övningsstund från första början genom att t ex bestämma ordningen på styckena som hen spelar. Eller ge ett val av två stycken som behandlar samma teknik: ”Vill du spela x stycke eller y stycke?”":
    "Children like to decide for themselves. Let the child be involved in their practice from the beginning by, for example, deciding the order of the pieces they play. Or give a choice of two pieces that deal with the same technique: “Do you want to play x piece or y piece?”",
  "Var lyhörd för dagsform och känn efter när det är dags att sluta - det är inte värt att övningsstunden får ett dåligt slut för att få in det där sista stycket eller för att man absolut skulle öva ett stycke man fått i läxa som barnet inte vill spela den dagen. (Talar av egen erfarenhet!)":
    "Be attentive to the current mood and know when it's time to stop - it's not worth ending the practice session on a bad note just to fit in that last piece or to force practicing a piece assigned as homework that the child doesn't want to play that day. (Speaking from personal experience!)",
  "Äldre barn kan få ännu mer egen kontroll genom att skriva upp övningslistor, s.k. charts, och kryssa i när man övat något. Ju äldre barn, ju mera eget ansvar för sitt övande. Vilket inte ska förleda en att tro att barnen kan vara helt självgående i övningen. Min erfarenhet är att upp till och med mellanstadie-åldern, och i vissa fall ännu längre, är det en stor fördel om föräldrar är med både på lektioner samt assisterar med övningen hemma.":
    "Older children can gain even more control by writing practice lists, so-called charts, and checking off items as they practice. The older the child, the more responsibility they take for their own practice. However, this should not lead one to believe that children can be completely independent in their practice. In my experience, up to and including elementary school age, and in some cases even longer, it is a great advantage for parents to attend both lessons and assist with practice at home.",
  "Att få spela med andra barn är en viktig del av motivationen. Jag kan inte nog betona hur viktiga grupplektioner är av denna anledning. Här får barnen träffa andra barn som sätter spelandet i ett socialt sammanhang. Att arbeta i grupp ger många möjligheter som man inte har tillgång till när man har enskild lektion. Plus att det är så roligt att spela tillsammans!":
    "Playing with other children is an important part of motivation. I cannot stress enough how important group lessons are for this reason. Here, children meet other children who put playing in a social context. Working in a group offers many opportunities that are not available in individual lessons. Plus, it is so fun to play together!",

  "Tyvärr, den sidan finns inte!": "Sorry, Page Not Found!",
  "Vi kunde inte hitta sidan du letar efter. Kanske har du skrivit fel i URL:en? Var noga med att kolla stavningen.":
    "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.",
  "Gå tillbaka": "Go back",

  // privacy-policy
  "Integritetspolicy för strakstudio.se": "Privacy Policy for strakstudio.se",
  "Senast uppdaterad: 2024-01-10": "Last updated: 2024-01-10",
  "1. Inledning": "1. Introduction",
  "Välkommen till strakstudio.se. Vi är engagerade i att skydda integriteten för våra användare och besökare. Denna integritetspolicy beskriver våra metoder för insamling, användning och delning av din personliga information.":
    "Welcome to strakstudio.se. We are committed to protecting the privacy of our users and visitors. This Privacy Policy outlines our practices regarding the collection, use, and sharing of your personal information.",
  "2. Insamling av Data": "2. Data Collection",
  "a. För Alla Användare och Besökare:": "a. For All Users and Visitors:",
  "Vi samlar in information som du tillhandahåller när du interagerar med vår webbplats, till exempel när du fyller i formulär eller skickar meddelanden.":
    "We collect information that you provide when you interact with our website, such as when you fill out forms or send messages.",
  "Vi samlar automatiskt in viss information när du besöker vår webbplats, såsom din IP-adress och webbläsartyp.":
    "We automatically collect certain information when you visit our website, such as your IP address and browser type.",
  "b. För Administratörer:": "b. For Administrators:",
  "Utöver ovanstående kan administratörer tillhandahålla ytterligare personlig information som krävs för kontohantering och autentisering.":
    "In addition to the above, administrators may provide additional personal information required for account management and authentication.",
  "3. Användning av Data": "3. Data Usage",
  "Vi använder din information för att tillhandahålla och förbättra våra tjänster, svara på dina förfrågningar och hantera vår webbplats.":
    "We use your information to provide and improve our services, respond to your inquiries, and manage our website.",
  "Vi kan använda din e-postadress för att kommunicera med dig, om du har valt att ta emot kommunikation från oss.":
    "We may use your email address to communicate with you, if you've opted to receive communications from us.",
  "Vi använder din information för att möjliggöra administrativa funktioner, inklusive att läsa och svara på användarmeddelanden.":
    "We use your information to enable administrative functions, including reading and responding to user messages.",
  "Administratörer kan använda en tredjepartstjänst (t.ex. Gmail) för att skicka svar. Vi ser till att dessa tjänster följer våra integritetsstandarder.":
    "Administrators may use a third-party service (e.g., Gmail) to send replies. We ensure that these services comply with our privacy standards.",
  "4. Delning av Data": "4. Data Sharing",
  "Vi säljer eller hyr inte ut dina personuppgifter till tredje part.":
    "We do not sell or rent your personal data to third parties.",
  "Vi kan dela din information med tredjepartsleverantörer för att utföra tjänster på våra vägnar, såsom webbhotell eller e-postkommunikation.":
    "We may share your information with third-party service providers to perform services on our behalf, such as website hosting or email communications.",
  "Vi kan avslöja din information om det krävs enligt lag eller om det är nödvändigt för att skydda våra rättigheter eller säkerheten för andra.":
    "We may disclose your information if required by law or if necessary to protect our rights or the safety of others.",
  "5. Användares Rättigheter": "5. User Rights",
  "Du har rätt att få tillgång till, korrigera eller radera din personliga information.":
    "You have the right to access, correct, or delete your personal information.",
  "Du kan när som helst välja att inte ta emot marknadsföringskommunikation från oss.":
    "You can opt-out of receiving promotional communications from us at any time.",
  "6. Ändringar av Denna Policy": "6. Changes to This Policy",
  "Vi kan uppdatera denna policy från tid till annan. Vi kommer att meddela dig om eventuella ändringar genom att publicera den nya policyn på denna sida.":
    "We may update this policy from time to time. We will notify you of any changes by posting the new policy on this page.",
  "7. Kontakta Oss": "7. Contact Us",
  "Om du har några frågor om denna integritetspolicy, vänligen kontakta oss på strakstudio.se, via kontaktformuläret.":
    "If you have any questions about this Privacy Policy, please contact us through the contact form on strakstudio.se.",

  // Dashboard - Messages
  Från: "From",
  Mejl: "Email",
  "Laddar...": "Loading...",
  "Inga meddelanden hittades": "No messages found",
  "Email kopierad till urklipp": "Email copied to clipboard",
  "Kopiera email": "Copy email",
  Telefon: "Phone",
  Stäng: "Close",
  "Visar X till Y av Z meddelanden": "Showing X to Y of Z messages",
  Föregående: "Previous",
  Nästa: "Next",
  "Sida X av Y": "Page X of Y",
  Databasfel: "Database Error",
  "Kunde inte ladda meddelanden från databasen. Försök igen senare.":
    "Failed to load messages from the database. Please try again later.",
  "Försök igen": "Try Again",
  "Meddelandet har tagits bort": "Message deleted",
  "Ta bort": "Delete",
  Validering: "Confirmation",
  "Är du säker på att du vill ta bort det här meddelandet från":
    "Are you sure you want to delete this message from",
  Avbryt: "Cancel",

  // Dashboard - Video Library
  "Ny video": "New Video",
  "Lägg till ny video": "Add New Video",
  "Lägg till en ny video i videobiblioteket.":
    "Add a new video to the video library.",
  Titel: "Title",
  Beskrivning: "Description",
  "Video-ID": "Video ID",
  "Lägg till": "Add",
  Tillagd: "Added!",
  "Något gick fel": "Something went wrong",
  Miniatyr: "Thumbnail",
  Åtgärder: "Actions",
  Redigera: "Edit",
  "Video-ID kopierat": "Video ID copied",
  "Kopiera video-ID": "Copy video ID",
  'Kopierade "{videoId}" till urklipp': 'Copied "{videoId}" to clipboard',
  "Kunde inte kopiera": "Failed to copy",
  "Kunde inte kopiera video-ID till urklipp":
    "Could not copy video ID to clipboard",
  "Inga videor valda": "No videos selected",
  "X video(r) valda": "X video(s) selected",
  "Ta bort valda": "Delete Selected",
  "Ta bort valda videor": "Delete selected videos",
  "Är du säker på att du vill ta bort X video(r)? Denna åtgärd kan inte ångras.":
    "Are you sure you want to delete X video(s)? This action cannot be undone.",
  "Ta bort X video(r)": "Delete X video(s)",
  "Redigera video": "Edit Video",
  "Uppdatera videoinformation.": "Update video information.",
  Uppdatera: "Update",
  Uppdaterad: "Updated!",
  "Kunde inte ladda videor från databasen. Försök igen senare.":
    "Failed to load videos from the database. Please try again later.",

  // Dashboard - Analytics
  "Välkommen tillbaka!": "Welcome back!",
  "Detta är strakstudio.se's dashboardvy, som ger insikter om våra användare och applikationstrender.":
    "This is strakstudio.se's dashboard view, providing insights about our users and application trends.",
  "Totalt antal besökare": "Total number of visitors",
  "Totalt antal registrerade användare": "Total Registered Users",
  "Totalt antal meddelanden": "Total messages",
  Ny: "New",
  "Ingen förändring": "No change",
  "Antal unika besökare varje dag": "Number of unique visitors each day",
  "Ny mätmetod": "New measurement method",
  "Besök efter enhet": "Visits by device",
  "Besök efter kanal": "Visits by channel",
  "Google organiskt": "Google organic",
  "Annan sökmotor": "Other search",
  "Facebook och Instagram": "Facebook and Instagram",
  "Annan social": "Other social",
  Direkt: "Direct",
  "Egna domäner": "Own domains",
  "Annan hänvisning": "Other referral",
  "Föregående period": "Previous period",
  "Visa hänvisare": "Show referrers",
  "Dölj hänvisare": "Hide referrers",
  "Ingen trafik än": "No traffic yet",
  "Besök efter land": "Visits by Country",
  "Fel vid laddning av data": "Error loading data",
  "Ingen data för perioden": "No data for this period",
  "vs föregående period": "vs previous period",
  "Antal unika besökare varje vecka": "Number of unique visitors each week",
  "Unika besökare per kanal": "Unique visitors by channel",
  "Mest lästa sidorna": "Most read pages",
  "Besökare per språk": "Visitors by language",
  "Från besök till inskickat formulär": "From visit to submitted form",

  // Dashboard - Date range
  Period: "Period",
  "7 dagar": "7 days",
  "30 dagar": "30 days",
  "90 dagar": "90 days",
  "Denna termin": "This term",
  "Förra terminen": "Last term",
  Till: "To",
  "Jämfört med": "Compared with",

  // Dashboard - Top pages and language split
  Toppsidor: "Top pages",
  Sida: "Page",
  Besökare: "Visitors",
  Sidvisningar: "Page views",
  Ingångar: "Entries",
  "Visa alla": "Show all",
  Alla: "All",
  Svenska: "Swedish",
  Engelska: "English",
  Språkfördelning: "Language split",
  Okänd: "Unknown",

  // Dashboard - Search Console
  Sökprestanda: "Search performance",
  "Från Google Search Console": "From Google Search Console",
  Klick: "Clicks",
  Visningar: "Impressions",
  CTR: "CTR",
  Snittposition: "Average position",
  Toppsökord: "Top queries",
  "Toppsidor i sök": "Top pages in search",
  Sökord: "Query",
  Position: "Position",
  "Bevakat sökord": "Watched query",
  "Data t.o.m.": "Data through",
  "Senaste synkningen misslyckades": "Latest sync failed",
  "Search Console är inte kopplad": "Search Console is not connected",
  "Sätt GOOGLE_SEARCH_CONSOLE_CREDENTIALS och SEARCH_CONSOLE_SITE_URL, och lägg till tjänstekontot som användare på egendomen i Search Console.":
    "Set GOOGLE_SEARCH_CONSOLE_CREDENTIALS and SEARCH_CONSOLE_SITE_URL, and add the service account as a user on the property in Search Console.",

  // Dashboard - Conversion funnel and attribution
  Konverteringstratt: "Conversion funnel",
  "Nådde formulärsida": "Reached a form page",
  "Inskickade formulär": "Submissions",
  Köanmälningar: "Waiting list signups",
  "av föregående steg": "of previous step",
  Konverteringar: "Conversions",
  "Okänd källa": "Unknown source",
  Källa: "Source",
  Landningssida: "Landing page",
  Kampanj: "Campaign",

  // Dashboard - Applications
  Totalt: "Total",
  ID: "ID",
  Adress: "Address",
  "Öppna vägbeskrivning": "Open directions",
  "Kopiera adress": "Copy address",
  "Kopierat!": "Copied!",
  "Här finns vi!": "Here we are!",
  "Kunde inte ladda ansökningar från databasen. Försök igen senare.":
    "Failed to load applications from the database. Please try again later.",

  // Dashboard - Waiting List
  "Kunde inte ladda kölista från databasen. Försök igen senare.":
    "Failed to load waiting list from the database. Please try again later.",
  "Kölista uppdaterad": "Waiting list updated",
  "Kunde inte uppdatera": "Could not update",

  // Dashboard - Applications
  "Ansökan uppdaterad": "Application updated",

  // Dashboard - Bookings
  Bokningar: "Bookings",
  Lärare: "Teacher",
  "Välj lärare": "Select teacher",
  "Namn på ny lärare": "New teacher name",
  "Tryck Enter för att skapa": "Press Enter to create",
  Filter: "Filter",
  "Alla blocktyper": "All block types",
  "Nytt block": "New block",
  "Redigera veckoblock": "Edit weekly block",
  "Skapa veckoblock": "Create weekly block",
  Veckodag: "Weekday",
  Tid: "Time",
  Start: "Start",
  Slut: "End",
  Typ: "Type",
  "Välj typ...": "Select type…",
  Anteckningar: "Notes",
  Spara: "Save",
  "Sparar...": "Saving…",
  "individual-lesson-adult": "Individual lesson (adult)",
  "individual-lesson-child": "Individual lesson (child)",
  "group-lesson-children": "Group lesson (children)",
  Grupp: "Group",
  "individual-lesson-suzuki": "Individual lesson (Suzuki)",
  unavailable: "Break / unavailable",
  "Hantera lärare": "Manage teachers",
  "Skapa lärare": "Create teacher",
  "Skapar...": "Creating…",
  "Inga lärare": "No teachers",
  "Skapa, byt namn och aktivera/inaktivera lärare.":
    "Create, rename and enable/disable teachers.",
  "Hantera blocktyper": "Manage block types",
  "Ändra för hela gruppen": "Apply to entire group",
  ApplyToGroup: "Apply to entire group",
  Blocktyper: "Block types",
  "Importera från block": "Import from blocks",
  "Skapa blocktyp": "Create block type",
  "Används i databasen": "Used in the database",
  Färg: "Color",
  Ordning: "Order",
  Aktiv: "Active",
  Inaktiv: "Inactive",
  Förhandsvisning: "Preview",
  "Inga blocktyper": "No block types",
  "Inget att importera": "Nothing to import",
  "Kunde inte spara": "Could not save",
  "Kunde inte skapa": "Could not create",
  Sparat: "Saved",
  "Importerade blocktyper": "Imported block types",
  Tillbaka: "Back",
  VisibleToClients: "Visible to clients",
  HiddenFromClients: "Hidden",
  "Inga tider": "No slots",
  "Tillgängliga tider": "Available slots",
  "Boka en ledig tid direkt i kalendern.":
    "Book an available slot directly in the calendar.",
  "Inga sparade platser": "No saved locations",

  // Bookings - API errors
  "Ogiltig veckodag": "Invalid weekday",
  "Ogiltigt tidsintervall": "Invalid time range",
  "Blocket överlappar ett befintligt block": "Block overlaps an existing block",
  "Block hittades inte": "Block not found",
  "Start måste vara före slut": "Start must be before end",
  "Regel hittades inte": "Rule not found",
  "Tiden är utanför lärarens tidsram": "Time is outside of teacher timeframe",
  "Bokningen överlappar en befintlig bokning":
    "Booking overlaps with an existing booking",
  "Återkommande bokningar måste inkludera COUNT eller UNTIL":
    "Recurring bookings must include COUNT or UNTIL",
  "Återkommande serie för lång (max ~1 år)":
    "Recurring series too long (max ~1 year)",
  "Återkommande bokning innehåller tider utanför lärarens tidsram":
    "Recurring booking contains occurrences outside teacher timeframe",
  "Återkommande bokning överlappar en befintlig bokning":
    "Recurring booking overlaps an existing booking",
  "Serien hittades inte": "Series not found",
  "Tiden utanför lärarens tidsram": "Time outside of teacher timeframe",
  "Tidsluckan är inte längre tillgänglig": "Time slot no longer available",
  "Lärare hittades inte": "Teacher not found",

  // Dashboard - Metadata titles
  "Dashboard: Meddelanden": "Dashboard: Messages",
  "Dashboard: Videohantering": "Dashboard: Video Library",
  "Dashboard | Analys": "Dashboard | Analytics",
  "Dashboard: Ansökningar": "Dashboard: Applications",
  "Dashboard: Kölista": "Dashboard: Waiting List",

  // Waiting List Settings
  LocationUpdated: "Location updated",
  LocationAdded: "Location added",
  AreYouSure: "Are you sure?",
  LocationDeleted: "Location deleted",
  WaitingListSettings: "Waiting List Settings",
  NewLocationName: "New location name",
  AddLocation: "Add location",
  Status: "Status",
  PublicView: "Public view",
  OpenApplyNow: "Open / Apply Now",
  WaitingList: "Waiting List",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  Boka: "Book",
  "önskad tid": "Preferred time",
  "Preliminär tid": "Preliminary time",
  "Du ansöker om en tid inom detta intervall. Lektionslängden väljs nedan.":
    "You are requesting a time within this interval. Lesson length is selected below.",
  "Fiol- och cellolektioner i Stockholm": "Violin & Cello Lessons in Stockholm",
  "Stockholm Stråkstudio är en musikskola för stråkinstrument i Vällingby, nära Bromma och Solna. Vi undervisar enligt Suzukimetoden och traditionell metod, för nybörjare såväl som avancerade elever.":
    "Stockholm Stråkstudio is a string music school in Vällingby, near Bromma and Solna. We teach with the Suzuki method as well as traditional approaches, for beginners and advanced students alike.",
  "Fiollektioner för barn & ungdom": "Violin lessons for children & youth",
  "från 3 år, med förälder som övningspartner. Undervisning vid Kristofferskolan (Brommaplan), i Vällingby och i Hagalund.":
    "from age 3, with a parent as practice partner. Lessons at Kristofferskolan (Brommaplan), in Vällingby, and in Hagalund.",
  "Fiollektioner för vuxna": "Violin lessons for adults",
  "nybörjare eller återupptagare — upplägget anpassas efter dig.":
    "beginners and returners welcome — the setup is adapted to you.",
  "Suzukifiol länk": "Suzuki violin",
  "modersmålsmetoden där barn lär sig spela som de lär sig tala, med föräldern som stöd.":
    "the mother-tongue approach where children learn to play the way they learn to speak, with a parent's support.",
  Cellolektioner: "Cello lessons",
  "för barn och vuxna hos vår cellopedagog David Hurtado Gomez.":
    "for children and adults with our cello teacher David Hurtado Gomez.",
  "aktuella avgifter och terminsplanering.": "current fees and term planning.",
  "Undrar du något?": "Questions?",
  eller: "or",
} as const;

export default en;
